/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

define([
    "backbone",
    "underscore",
    "service/stub",
    "service/factory",
    "client/localized_model",
    "service/cross_domain_ajax_channel"
  ], function (
    Backbone,
    _,
    Stub,
    ServiceFactory,
    LocalizedModel,
    CrossDomainAjaxChannel
  ) {
  
    var Generate = {};

    function SSEDataParser(dataCallback) {
      this.startPos = 0;
      this.dataCallback = dataCallback;
    }

    _.extend(SSEDataParser.prototype, {
      
      parseGenerateStreamLineAsJSON: function(line) {
        if (!line) return {};
        
        try {
          var json = JSON.parse(line.replace('data:', ''));
          var responseObj = _.extend({}, json.token, { generated_text: json.generated_text, retrieval_details: json.retrieval_details });
          delete responseObj.id; // Since id here might not be unique, let the backbone handle the id itself.
          return responseObj;
        } catch (e) {
          return {};
        }
      },

      onDataUpdate: function(data) {
        var startPos = this.startPos;
        var findPos;
        while ((findPos = data.indexOf('\n', startPos)) >= startPos) {
          var endPos = findPos + 1;
          var text = data.substring(startPos, endPos);
          text = text.trim();
          startPos = endPos;
          this.startPos = endPos;
          if (text.length > 0) {
            try {
              var parsedItem = this.parseGenerateStreamLineAsJSON(text);
              if (parsedItem != null && !_.isEmpty(parsedItem)) {
                this.dataCallback(parsedItem); // Add to the collection
              }
            } catch (e) {
              console.error('Failed to parse item:', text, e);
            }
          }
        }               
      }
      
    });
    
    Generate.SSEDataParser = SSEDataParser;
    
    Generate.Model = LocalizedModel.extend({});
  
    Generate.Collection = Backbone.Collection.extend({
  
      model: Generate.Model,
      fetch: function (url, postData, options, channelOptions, callback) {
        this.reset();
        var that = this;
        var responseObserver = createResponseObserver();
        var optionsClone = _.clone(options || {});
        if (optionsClone.parse === void 0) optionsClone.parse = true;

        responseObserver.on("response", function (response, url) {
          response.id = url.id;
          response.channelOptions = channelOptions;
          that.response = response;
          that.add(response, optionsClone);
          that.remove(response);
          responseObserver.off();
        });

        responseObserver.on("error", function (error) {
          // Because when success it fails to parse text stream as JSON
          if (_.isFunction(options.onComplete)) {
            options.onComplete(error);
          }
          if (error.status == 200) return;

          console.error(error);
          callback(error)
          responseObserver.off();
        });
  
        var stub = new DataServiceStub();
        var channel = new CrossDomainAjaxChannel({ url: url }, channelOptions);
        var sseParser = new SSEDataParser(_.bind(this.add, this));

        var customChannelOptions = {
          generate: true,
          beforeSend: function(jqXHR) {
            if (_.isFunction(options.onXHRset)) {
              options.onXHRset(jqXHR);
            }
          },
          xhrFields: {
            onprogress: function(event) {
              if (event.currentTarget.status >= 400) {
                return;
              }
              sseParser.onDataUpdate(event.currentTarget.responseText);
            }
          }
        }
        stub.cast(channel, postData, responseObserver, customChannelOptions);
      }
    });
  
    var DataServiceStub = Generate.DataServiceStub = Stub.extend({
      path: "/api/chat/v1beta/generate",
      options: {
        method: "POST",
        headers: {"Content-type": "application/json; charset=UTF-8"}
    }
    });
  
    function createResponseObserver() {
      var responseObserver = {};
      return _.extend(responseObserver, Backbone.Events);
    }
    
    var GenerateServiceFactory = Generate.ServiceFactory = function () { }
  
    _.extend(GenerateServiceFactory.prototype, ServiceFactory.prototype, {
      cast: function (channel) {
        new DataServiceStub().cast(channel);
      },
  
      getChatFramePath: function () {
        return new DataServiceStub().path;
      }
  
    });
    return Generate;
  });
  
